import styled from 'styled-components';

export const Body = styled.div`
  width: 100%;
  background-image: url('images/wallpaper.png');
  background-size: cover;
`;

export const FormWrapper = styled.div`
  position: initial;
  height: 26rem;
  width: 28rem;
  max-width: 26rem;
  z-index: 3;
  background-color: #1d1e1f4f;
  padding: 2rem;
  border-radius: 20px;

  @media screen and (max-width: 870px) {
    width: 19rem;
  }
`;
